import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Spacer, Text } from '@Sage/hoi-poi-ui';
import { AvatarSizes, UserAvatar } from 'components/avatar';

import './styles.scss';

const ImageRow = memo(({ id, label }) => (
    <div className="fm-select-row--flex">
        <UserAvatar id={id} size={AvatarSizes.NORMAL} />
        <Spacer x={2} />
        <Text type="body" isTruncated useTooltip>
            {label}
        </Text>
    </div>
));

ImageRow.displayName = 'ImageRow';

ImageRow.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node,
};

export default ImageRow;
